import { Customer } from "cy-api/simple-payments/customer/models";
import { CustomerDocument } from "cy-api/simple-payments/customer-documents/models";

export type RegistrationSectionStatus = "complete" | "incomplete" | "partial";
export enum RegistrationSections {
  Address = "address",
  Identification = "identification",
  FinancialDocuments = "financialDocuments",
}
export type RegistrationSectionState = Record<
  RegistrationSections,
  { status: RegistrationSectionStatus; disabled: boolean }
>;
export interface RegistrationState {
  isComplete: boolean;
  sections: RegistrationSectionState;
}

export type RegistrationStatus = "incomplete" | "pending" | "complete";
export function getRegistrationState(
  customer: Customer,
  documents: CustomerDocument[],
) {
  const addressRequired =
    !customer.physical_address.city ||
    !customer.physical_address.address_line_1;
  const identificationRequired =
    !customer.identification.number || !customer.identification.country_code;
  const financialDocumentsRequired = documents.some(
    (x) => x.status === "needed",
  );

  const state: RegistrationSectionState = {
    address: {
      status: addressRequired ? "incomplete" : "complete",
      disabled: false,
    },
    identification: {
      status: identificationRequired ? "incomplete" : "complete",
      disabled: addressRequired,
    },
    financialDocuments: {
      status: financialDocumentsRequired ? "incomplete" : "complete",
      disabled: addressRequired,
    },
  };
  const isComplete =
    state.address.status === "complete" &&
    state.identification.status === "complete" &&
    state.financialDocuments.status === "complete";

  const status: RegistrationStatus = !isComplete
    ? "incomplete"
    : customer.status === "pending" ||
        customer.status === "pending_account_details"
      ? "pending"
      : "complete";
  return { state, status };
}
